//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import TransferBetweenWarehouseModel from '@/models/Purchase/PchPurchaseOrder'
import Translator from '@/services/translator'
import fields from './fields'

//
export default {
    name: 'purchase-order-update',
    components: {
        'model-form': ModelForm,
    },
    computed: {
        //
        ...mapState('AuthModule', ['user']),
        ...mapState('SnackbarModalModule', ['responseConfirm']),

        /**
         * @description
         * Fields props
         *
         * @return     {Object}  The field props params
         */
        fieldsProps() {
            return {
                g_branch_office_id: this.user.hr_employee.g_branch_office_id,
                is_service: this.formData.is_service,
            }
        },

        /**
         *
         */
        formProps() {
            return {
                editable: false,
                loading: this.formBusy,
                fields: fields(this.fieldsProps),
            }
        },
    },
    data() {
        return {
            formBusy: false,
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        //
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        confirmDispatch() {
            this.$refs.form.setWait(true).then(this.dispatch)
        },

        /**
         *
         */
        dispatch(model) {
            model
                .dispatch()
                .attach()
                .then(this.showSuccessDispatch)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'transfer-between-warehouse' })
        },

        /**
         *
         */
        reset() {
            this.formBusy = true
            TransferBetweenWarehouseModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        setFormData(model) {
            this.formBusy = false
            this.formData = model.reset()
        },

        /**
         *
         */
        showError(error) {
            this.showSnackbar(
                'error',
                'Error.',
                Translator(TransferBetweenWarehouseModel, error.response.data)
            )
        },

        /**
         *
         */
        showSnackbar(type, title, message, callback) {
            this.initSnackbar(this.fillSnack(type, title, message))
            if (typeof callback === 'function') callback()
        },

        /**
         *
         */
        showSuccess() {
            this.showSnackbar(
                'success',
                'Éxito.',
                'Guía de intercambio creada.',
                this.redirect
            )
        },

        /**
         *
         */
        showSuccessDispatch() {
            this.resetSnackbarState()
            this.showSnackbar(
                'success',
                'Éxito.',
                'Guía de intercambio despachada.',
                this.redirect
            )
        },

        /**
         *
         */
        submit() {
            this.$refs.form.setWait(true).then(this.update)
        },

        /**
         *
         */
        submitDispatch() {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('despachar guía')
            this.showSnackbar(
                'warning',
                'Despachar.',
                '¿Confirma el despacho de esta guía?'
            )
        },

        /**
         *
         */
        update(model) {
            model
                .update()
                .then(this.showSuccess)
                .catch(this.showError)
                .then(this.$refs.form.setWait)
        },
    },
    beforeMount() {
        this.setTitleTopBar('Datos de orden de compra')
    },
    mounted() {
        this.reset()
    },
    watch: {
        /**
         *
         */
        async responseConfirm(value) {
            switch (value) {
                case 'despachar guía':
                    this.confirmDispatch()
                    break
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PURCHASE_ORDER')) ctx.$router.push('/')
        })
    },
}
